import { beamstarSessionDetailSchema, beamstarSummarySchema, getBeamstarFlagsResponseSchema, getBeamstarSessionsResponseSchema, } from '@consigli/types';
import { createTransformer } from './shared/base-api';
export const beamstarApiEndpoints = (builder, buildingAgentBaseUrl) => ({
    getBeamstarSummary: builder.query({
        query: ({ days }) => ({
            url: `${buildingAgentBaseUrl}/admin/summary`,
            method: 'GET',
            params: { days },
        }),
        transformResponse: createTransformer(beamstarSummarySchema, 'GetBeamstarSummary'),
    }),
    getBeamstarSessions: builder.query({
        query: ({ days }) => ({
            url: `${buildingAgentBaseUrl}/admin/sessions`,
            method: 'GET',
            params: { days },
        }),
        transformResponse: createTransformer(getBeamstarSessionsResponseSchema, 'GetBeamstarSessions'),
    }),
    getBeamstarSession: builder.query({
        query: ({ conversationId }) => ({
            url: `${buildingAgentBaseUrl}/admin/sessions/${conversationId}`,
            method: 'GET',
        }),
        transformResponse: createTransformer(beamstarSessionDetailSchema, 'GetBeamstarSession'),
    }),
    getBeamstarFlags: builder.query({
        query: ({ days }) => ({
            url: `${buildingAgentBaseUrl}/admin/flags`,
            method: 'GET',
            params: { days },
        }),
        transformResponse: createTransformer(getBeamstarFlagsResponseSchema, 'GetBeamstarFlags'),
    }),
});
